import React from 'react'
import PropTypes from 'prop-types'
import { useCallback } from 'sb-hooks'
import actions from 'redux/actions'
import { constants, snowplow } from 'common/helpers'
import { intlMessageShape } from 'sb-react-intl'

import Button from 'components/_new/Button/Button'

import messages from './messages'


const UnpauseButton = (props) => {
  const {
    className, size, unpauseType, placement, color, weight, rightIcon,
    uppercase, title, fullWidth, dataTestId, id, halfPadding,
  } = props

  const handleClick = useCallback(() => {
    snowplow.track(constants.snowplowEvents.unpauseClick, { placement }, false)
    actions.models.subscription.unpause({ unpauseType, placement })
  }, [ unpauseType, placement ])

  return (
    <Button
      className={className}
      id={id}
      size={size}
      title={title}
      color={color}
      weight={weight}
      fullWidth={fullWidth}
      rightIcon={rightIcon}
      uppercase={uppercase}
      halfPadding={halfPadding}
      dataTestId={dataTestId}
      onClick={handleClick}
    />
  )
}

UnpauseButton.propTypes = {
  placement: PropTypes.string.isRequired,
  className: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
  weight: PropTypes.string,
  uppercase: PropTypes.bool,
  title: PropTypes.shape(intlMessageShape),
  dataTestId: PropTypes.string,
  rightIcon: PropTypes.string,
}

UnpauseButton.defaultProps = {
  size: 'md',
  color: 'brand',
  weight: 'medium',
  uppercase: true,
  title: messages.title,
  dataTestId: constants.testIds.profile.orderStatusButtons.unpause,
}


export default UnpauseButton
